import React from "react";
import { Skeleton, Flex, Tabs } from "@mantine/core";
import { Section } from "../Container/Section";
import { SectionTitleWithExp } from "../customTypo/SectionTitleWithExp";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import colorsCustom from "../../designTokens/colorsCustom";

export const ChartSkeleton = ({ isMobile, title }) => {
	return (
		<Section>
			<SectionTitleWithExp
				title={title}
				isMobile={isMobile}
			/>
			<CardContainerRetro
				p={isMobile ? "16px" : "24px 32px 48px 24px"}
				bg={colorsCustom.paper}
				weight="bold"
				rd={16}
				style={{ position: "relative" }}
			>
				<Tabs defaultValue="profile" w="100%">
					<Tabs.List>
						<Tabs.Tab value="profile" fz={isMobile ? "md" : "lg"}>
							<Skeleton height={16} width={100} />
						</Tabs.Tab>
					</Tabs.List>
					<Tabs.Panel value="profile" pt="md">
						<Flex direction={"column"} gap={16} w={"100%"}>
							{/* 설명 텍스트 Skeleton */}
							<Skeleton height={isMobile ? 14 : 16} width="80%" />
							
							{/* 컨트롤 영역 Skeleton */}
							<Flex w={"100%"} align="center" gap={16}>
								<Skeleton height={isMobile ? 32 : 40} width={120} />
								<Skeleton height={24} width={1} />
								<Flex align="center" gap={8}>
									<Skeleton height={isMobile ? 24 : 32} width={isMobile ? 24 : 32} />
									<Skeleton height={isMobile ? 16 : 20} width={80} />
									<Skeleton height={isMobile ? 24 : 32} width={isMobile ? 24 : 32} />
								</Flex>
							</Flex>
							
							{/* 차트 영역 Skeleton */}
							<Flex w={"100%"}>
								<Skeleton 
									height={isMobile ? 240 : 320} 
									width="100%" 
									radius="md"
								/>
							</Flex>
						</Flex>
					</Tabs.Panel>
				</Tabs>
			</CardContainerRetro>
		</Section>
	);
}; 